export default __webpack_public_path__ + "./images/ki.80b45b0d.png";